import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, input } from '@angular/core'
import { ButtonComponent } from '@ftr/foundation'
import { RealTimeSttMetadata } from '../../../types'
import { RealTimeSttHearingHeader } from '../../smart'
import { HearingSectionAnnotationFormComponent, HearingSectionFormModel } from '../hearing-annotation-form'

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ftr-real-time-stt-hearing-header',
  templateUrl: './real-time-stt-hearing-header.component.html',
  imports: [HearingSectionAnnotationFormComponent, ButtonComponent],
})
export class RealTimeSttHearingHeaderComponent {
  @HostBinding('attr.data-transcript-id')
  @Input()
  transcriptAugmentationId: string | undefined

  @Input()
  hearingHeader: RealTimeSttHearingHeader & RealTimeSttMetadata

  readOnly = input(false)

  @Output()
  onHearingHeaderChanged = new EventEmitter<HearingSectionFormModel>()

  @Output()
  onHearingDeleted = new EventEmitter<void>()

  @Output()
  onSetHearingToOngoing = new EventEmitter<void>()

  hearingAnnotationChanged(value: HearingSectionFormModel): void {
    this.onHearingHeaderChanged.emit(value)
  }
}
